function init() {
  return new Promise((resolve, reject) => {
    try {
      let script = document.getElementById("fp");

      if (!script) {
        script = document.createElement("script");
        script.setAttribute("src", "/fp.js");
        script.setAttribute("id", "fp");
        document.head.appendChild(script);
        script.onload = async () => {
          resolve();
        };
      } else resolve();
    } catch (err) {
      reject(err);
    }
  });
}

function waitForIdle() {
  return new Promise(resolve => {
    if (window.requestIdleCallback) {
      requestIdleCallback(() => {
        resolve();
      });
    } else {
      setTimeout(() => {
        resolve();
      }, 500);
    }
  });
}

export async function get(waitForReady) {
  try {
    await init();
    if (waitForReady) await waitForIdle();
    const components = await FP.getPromise({
      excludes: { adBlock: true, webgl: false, enumerateDevices: true }
    });

    return FP.x64hash128(components.map(component => component.value).join(""));
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export default { get };
